// components/DeleteTransportModal.jsx

import { X, AlertTriangle, Trash2 } from "lucide-react";

const DeleteTransportModal = ({ show, transport, onClose, onConfirm }) => {
  if (!show || !transport) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4
                bg-white/10 bg-black/20 backdrop-blur-md border border-white/30 rounded-lg shadow-lg">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-bold text-gray-800">Confirmare Ștergere</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-8 h-8 text-red-600" />
          </div>
          <p className="text-gray-600 mb-2">
            Sunteți sigur că doriți să ștergeți transportul:
          </p>
          <p className="font-semibold text-gray-900 mb-1">{transport.id}</p>
          <p className="text-sm text-gray-500">{transport.client}</p>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-red-700 text-center font-medium">
            ⚠️ Această acțiune nu poate fi anulată!
          </p>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 border border-gray-200 rounded-xl text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Anulează
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors flex items-center justify-center"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Șterge Definitiv
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTransportModal;
